import React, { Component } from 'react';
import * as apis from '../../../common-utils/api_urls'
import { Link } from 'react-router-dom';
import * as translationUtils from '../../../common-utils/translation_utils'

/**
 * Orders Class renders Order menu sub-section
 */
class Orders extends Component {

  constructor(props){
    super(props);
    this.state = {
      all:'',
      open:''
    }
  }

  componentDidMount(){
    this.state[this.props.intialOrderType] = 'active';

    this.props.callbackFromParent(apis.getOrderUrl(this.props.intialOrderType));
  }

  /**
   * Handles URL change and passes order URL to MainWrapper Callback.
   */
  handleClick=(e, orderType)=>{
    window.loader(true);
    if(window.jQuery(e.target).children()[0]!==undefined){
      window.jQuery(e.target).children()[0].click();
    }
    if(orderType==='all'){
      this.setState({
        all:'active',
        open:''
      });
      this.props.callbackFromParent(apis.getOrderUrl(orderType));
    }else if(orderType==='open'){
      this.setState({
        all:'',
        open:'active'
      });
      this.props.callbackFromParent(apis.getOrderUrl(orderType));
    }
  }

  render() {
    return (
        <>
        <div className="ph-nav-group">
          <div className="ph-nav-group__header">{translationUtils.getTranslation(1717,'Orders')}</div>
            <ul className="ph-nav-group__list">
              <li className={this.state.all} onClick={(e)=>this.handleClick(e,'all')}><Link to={'/'+this.props.langCode+'/orders/all'}>{translationUtils.getTranslation(1837,'All Orders')}</Link></li>
              <li className={this.state.open} onClick={(e)=>this.handleClick(e,'open')}><Link to={'/'+this.props.langCode+'/orders/open'}>{translationUtils.getTranslation(1838,'Open Orders')}</Link></li>
            </ul>
        </div>
        </>
    );
  }
}

export default Orders;
